<template>
  <div class="achievements-carousel">
    <div class="carousel-dots">
      <div
        v-for="(achievement, index) in allAchievements"
        :key="index"
        class="dot-holder"
        :class="{ active: currentIndex === index }"
        @click="setCurrentIndex(index)"
        @pointerdown="setCurrentIndex(index)"
      >
        <div v-if="achievement.available" class="dot"></div>
        <svg
          v-if="!achievement.available"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-10 0v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-8z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AchievementsCarousel',
    props: {
      allAchievements: Array,
      selectedAchievement: Object,
    },
    data() {
      return {
        currentIndex: 0,
        touchStartX: 0,
        touchEndX: 0,
      };
    },
    watch: {
      selectedAchievement(newVal) {
        if (newVal) {
          const index = this.allAchievements.findIndex((a) => a.id === newVal.id);
          if (index !== -1) {
            this.currentIndex = index;
          }
        }
      },
    },
    methods: {
      selectAchievement(achievement) {
        this.$emit('achievement-selected', achievement);
      },
      setCurrentIndex(index) {
        this.currentIndex = index;
        this.selectAchievement(this.allAchievements[index]);
      },
      touchStart(e) {
        this.touchStartX = e.touches[0].clientX;
      },
      touchMove(e) {
        this.touchEndX = e.touches[0].clientX;
      },
      touchEnd() {
        const diff = this.touchStartX - this.touchEndX;
        const threshold = 50; // Minimum swipe distance

        if (Math.abs(diff) > threshold) {
          if (diff > 0) {
            // Swipe left
            this.nextSlide();
          } else {
            // Swipe right
            this.prevSlide();
          }
        }
      },
      nextSlide() {
        if (this.currentIndex < this.allAchievements.length - 1) {
          this.currentIndex++;
          this.selectAchievement(this.allAchievements[this.currentIndex]);
        }
      },
      prevSlide() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.selectAchievement(this.allAchievements[this.currentIndex]);
        }
      },
    },
    mounted() {
      console.log({ allAchievements: this.allAchievements });
      // If there's a selected achievement, set the carousel to that index
      if (this.selectedAchievement) {
        const index = this.allAchievements.findIndex((a) => a.id === this.selectedAchievement.id);
        if (index !== -1) {
          this.currentIndex = index;
        }
      }
    },
  };
</script>

<style scoped>
  .achievements-carousel {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px 0;
  }

  .carousel-dots {
    display: flex;
    gap: 8px;
    justify-content: center;
  }

  .dot-holder {
    width: 15px;
    height: 15px;
    padding: 3px;
    box-sizing: border-box;
    cursor: pointer;
    color: white;
    opacity: 0.3;
    transition: opacity 0.3s ease;
  }

  .dot-holder.active {
    opacity: 0.9;
  }

  .dot-holder svg {
    display: block;
  }

  .dot {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: white;
  }
</style>
